module.exports = __webpack_public_path__ + "static/img/three.6020c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radishImg/three.png
// module id = 018k
// module chunks = 1